import { CalendarRegular, LmPopover } from "@tamagui-extras/core";
import { LmMonth } from "./LmMonth";
import { Button, XStack } from "tamagui";
import { jsx } from "react/jsx-runtime";
function LmDatepickerPopover({
  activeMonths,
  monthsCount,
  firstDayOfWeek,
  labelFunctions,
  buttonProps,
  ...popoverProps
}) {
  return /* @__PURE__ */ jsx(
    LmPopover,
    {
      isBouncy: !0,
      ...popoverProps,
      contentProps: {
        padding: "$4",
        elevation: "$5",
        ...popoverProps?.contentProps
      },
      trigger: /* @__PURE__ */ jsx(
        Button,
        {
          icon: /* @__PURE__ */ jsx(CalendarRegular, {}),
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          ...buttonProps
        }
      ),
      children: /* @__PURE__ */ jsx(XStack, { space: !0, alignItems: "flex-start", children: activeMonths.map((month, index) => /* @__PURE__ */ jsx(
        LmMonth,
        {
          year: month.year,
          month: month.month,
          monthsCount,
          firstDayOfWeek,
          isFirst: monthsCount === 0 || index === 0,
          isLast: monthsCount === 0 || index === monthsCount - 1,
          ...labelFunctions
        },
        `${month.year}-${month.month}`
      )) })
    }
  );
}
export {
  LmDatepickerPopover
};
//# sourceMappingURL=LmDatepickerPopover.js.map
